import { combineEpics } from 'redux-observable'
import { Observable } from 'rxjs/Observable'

import { URL_CONST } from 'utils/urlConsts'

import { MAP_INCIDENT_TYPE_TO_URL_PREFIX } from '../constants'

import {
  addCommentError,
  addCommentSuccess,
  addReplyError,
  addReplySuccess,
  deleteCommentError,
  deleteCommentSuccess,
  editCommentError,
  editCommentSuccess,
  fetchCommentsError,
  fetchCommentsSuccess,
  saveCommunityUserError,
  saveCommunityUserSuccess,
} from './actions'
import {
  ADD_COMMENT_REQUEST_ASYNC,
  ADD_REPLY_REQUEST_ASYNC,
  COMMENTS_REQUEST_ASYNC,
  DELETE_COMMENT_REQUEST_ASYNC,
  EDIT_COMMENT_REQUEST_ASYNC,
  SAVE_NICKNAME_REQUEST_ASYNC,
  SET_REPORT_DATA,
  TOGGLE_COMMUNITY_TAB,
} from './constants'

const fetchCommentsEpic = (action$, store, { api, epicsErrorHandler }) =>
  action$
    .ofType(
      SET_REPORT_DATA,
      COMMENTS_REQUEST_ASYNC.INITIATE,
      EDIT_COMMENT_REQUEST_ASYNC.SUCCESS,
      DELETE_COMMENT_REQUEST_ASYNC.SUCCESS,
      ADD_COMMENT_REQUEST_ASYNC.SUCCESS,
      ADD_REPLY_REQUEST_ASYNC.SUCCESS,
      SAVE_NICKNAME_REQUEST_ASYNC.SUCCESS,
      TOGGLE_COMMUNITY_TAB
    )
    .filter((action) => {
      if (action.type === TOGGLE_COMMUNITY_TAB)
        return (
          window.location.href.indexOf(URL_CONST.incidents.attackdetails) !== -1 ||
          window.location.href.indexOf(URL_CONST.incidents.incidents) !== -1
        )
      return true
    })
    .mergeMap(() =>
      api.resolutionCenter
        .fetchReportComments(
          store.getState().resolutioncenter.reportComments.reportData.reportId,
          store.getState().resolutioncenter.reportComments.communityTab,
          MAP_INCIDENT_TYPE_TO_URL_PREFIX[
            store.getState().resolutioncenter.reportComments.reportData.reportType
          ]
        )
        .map((response) => fetchCommentsSuccess(response))
        .catch((error) => Observable.of(epicsErrorHandler(fetchCommentsError, error)))
        .takeUntil(action$.ofType(COMMENTS_REQUEST_ASYNC.CANCEL))
    )

const editCommentEpic = (action$, store, { api, epicsErrorHandler }) =>
  action$.ofType(EDIT_COMMENT_REQUEST_ASYNC.INITIATE).mergeMap((action) =>
    api.resolutionCenter
      .editReportComment(
        store.getState().resolutioncenter.reportComments.reportData.reportId,
        action.payload.commentId,
        { comment: action.payload.newText },
        MAP_INCIDENT_TYPE_TO_URL_PREFIX[
          store.getState().resolutioncenter.reportComments.reportData.reportType
        ]
      )
      .map((response) => editCommentSuccess(response))
      .catch((error) => Observable.of(epicsErrorHandler(editCommentError, error)))
      .takeUntil(action$.ofType(EDIT_COMMENT_REQUEST_ASYNC.CANCEL))
  )

const deleteCommentEpic = (action$, store, { api, epicsErrorHandler }) =>
  action$.ofType(DELETE_COMMENT_REQUEST_ASYNC.INITIATE).mergeMap((action) =>
    api.resolutionCenter
      .deleteReportComment(
        store.getState().resolutioncenter.reportComments.reportData.reportId,
        action.payload.commentId,
        MAP_INCIDENT_TYPE_TO_URL_PREFIX[
          store.getState().resolutioncenter.reportComments.reportData.reportType
        ]
      )
      .map((response) => deleteCommentSuccess(response))
      .catch((error) => Observable.of(epicsErrorHandler(deleteCommentError, error)))
      .takeUntil(action$.ofType(DELETE_COMMENT_REQUEST_ASYNC.CANCEL))
  )

const addCommentEpic = (action$, store, { api, epicsErrorHandler }) =>
  action$.ofType(ADD_COMMENT_REQUEST_ASYNC.INITIATE).mergeMap((action) =>
    api.resolutionCenter
      .addReportComment(
        store.getState().resolutioncenter.reportComments.reportData.reportId,
        {
          comment: action.payload.text,
          isCommunity: store.getState().resolutioncenter.reportComments.communityTab,
        },
        MAP_INCIDENT_TYPE_TO_URL_PREFIX[
          store.getState().resolutioncenter.reportComments.reportData.reportType
        ]
      )
      .map((response) => addCommentSuccess(response))
      .catch((error) => Observable.of(epicsErrorHandler(addCommentError, error)))
      .takeUntil(action$.ofType(ADD_COMMENT_REQUEST_ASYNC.CANCEL))
  )

const addReplyEpic = (action$, store, { api, epicsErrorHandler }) =>
  action$.ofType(ADD_REPLY_REQUEST_ASYNC.INITIATE).mergeMap((action) =>
    api.resolutionCenter
      .addReportComment(
        store.getState().resolutioncenter.reportComments.reportData.reportId,
        {
          comment: action.payload.text,
          parentId: action.payload.commentId,
          isCommunity: store.getState().resolutioncenter.reportComments.communityTab,
        },
        MAP_INCIDENT_TYPE_TO_URL_PREFIX[
          store.getState().resolutioncenter.reportComments.reportData.reportType
        ]
      )
      .map((response) => addReplySuccess(response))
      .catch((error) => Observable.of(epicsErrorHandler(addReplyError, error)))
      .takeUntil(action$.ofType(ADD_REPLY_REQUEST_ASYNC.CANCEL))
  )

const saveCommunityUserEpic = (action$, store, { api, epicsErrorHandler }) =>
  action$.ofType(SAVE_NICKNAME_REQUEST_ASYNC.INITIATE).mergeMap((action) =>
    api.resolutionCenter
      .saveCommunityUser(action.payload.nickname)
      .map((response) => saveCommunityUserSuccess(response))
      .catch((error) => Observable.of(epicsErrorHandler(saveCommunityUserError, error)))
      .takeUntil(action$.ofType(SAVE_NICKNAME_REQUEST_ASYNC.CANCEL))
  )

export default combineEpics(
  fetchCommentsEpic,
  editCommentEpic,
  deleteCommentEpic,
  addCommentEpic,
  addReplyEpic,
  saveCommunityUserEpic
)
